import React from "react";
import { VscClose } from "react-icons/vsc";
import { useNavigate } from "react-router-dom";
import cabinsLogo from "../assets/images/logo/Cabins.png";

const Sidebar = ({
  token,
  user,
  isSuperAdmin,
  onLogoutClick,
  showSidebar,
  setShowSidebar,
  onLogoClick,
  onBookingFormClick,
  onAllReservationsClick,
  onAddCabinClick,
  onMyCabinsClick,
  onMyReservationsClick,
  onUnderMaintenanceClick,
}) => {
  return (
    <main className="flex items-center justify-end">
      <main className="h-screen w-[18rem] md:w-[20rem] lg:w-[25rem] xl:hidden pt-3 px-4 lg:pt-5 lg:px-5 bg-primaryExtraLight2 text-neutral-300 shadow-md shadow-primary">
        <div className="h-full flex-row">
          <section className="flex items-center justify-between cursor-pointer">
            <div className="ProductName my-2" onClick={onLogoClick}>
              <img
                src={cabinsLogo}
                className="w-full h-5"
                // "& img": {
                //   width: "100%",
                //   height: "20px",
                // },
              />
            </div>
            <div onClick={() => setShowSidebar(!showSidebar)}>
              <VscClose className="h-8 w-8 text-secondary" />
            </div>
          </section>
          <section className="p-3 lg:px-10 lg:py-0 h-[calc(100vh_-_56px)] flex flex-col items-center justify-center">
            {user && (
              <div className="sidebar_Container" onClick={onBookingFormClick}>
                BOOKING FORM
              </div>
            )}
            {isSuperAdmin && (
              <>
                <div
                  className="sidebar_Container"
                  onClick={onAllReservationsClick}
                >
                  ALL RESERVATIONS
                </div>
                <div className="sidebar_Container" onClick={onAddCabinClick}>
                  ADD A CABIN
                </div>
                <div className="sidebar_Container" onClick={onMyCabinsClick}>
                  MY CABINS
                </div>
              </>
            )}
            {user && (
              <div
                className="sidebar_Container"
                //  id="last"
                onClick={onMyReservationsClick}
              >
                MY RESERVATIONS
              </div>
            )}
            <div
              className="sidebar_Container"
              onClick={onUnderMaintenanceClick}
            >
              ABOUT
            </div>
            <div
              className="sidebar_Container"
              onClick={onUnderMaintenanceClick}
            >
              FAQ
            </div>
            <div
              className="sidebar_Container"
              onClick={onUnderMaintenanceClick}
            >
              TEAM
            </div>
            {user ? (
              <div
                className="sidebar_Container text-error"
                //  id="logout"
                onClick={onLogoutClick}
              >
                LOGOUT
              </div>
            ) : null}
          </section>
        </div>
      </main>
    </main>
    //  <main className="h-screen w-screen z-50 lg:hidden p-16 bg-neutral-800 text-neutral-300">
    //    <div className="flex-row">
    //      <section className="flex items-center justify-end cursor-pointer">
    //        <div onClick={() => setShowSidebar(!showSidebar)}>
    //          <VscClose className="h-8 w-8" />
    //        </div>
    //      </section>
    //      <section className="flex-row items-center justify-center p-10">
    //        <div
    //          className="sidebar_Container"
    //          //  onClick={onHomeClick}
    //        >
    //          <span className="sidebar-number text-vscBlue">01.</span>
    //          <span>Home</span>
    //        </div>
    //        <div
    //          className="sidebar_Container"
    //          //  onClick={onWorksClick}
    //        >
    //          <span className="sidebar-number text-vscBlue">02.</span>
    //          <span>Works</span>
    //        </div>
    //        <div
    //          className="sidebar_Container"
    //          //  onClick={onAboutClick}
    //        >
    //          <span className="sidebar-number text-vscBlue">03.</span>
    //          <span>About</span>
    //        </div>
    //        <div
    //          className="sidebar_Container"
    //          //  onClick={onContactClick}
    //        >
    //          <span className="sidebar-number text-vscBlue">04.</span>
    //          <span>Contact</span>
    //        </div>
    //      </section>
    //    </div>
    //  </main>
  );
};

export default Sidebar;
